


































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import { Utils } from '@/globals/Utils';

@Component({})
export default class RadioGroupWidget extends Vue {

  @Inject()
  public $validator: any;

  @Prop({ type: String, default: 'payrollForm' })
  public formName!: string;

  @Prop(String)
  public staticInputId!: string;

  @Prop(Array)
  public radios!: any[];

  @Prop(String)
  public radioTitle!: string;

  @Prop(String)
  public hiddenRadioTitle!: string;

  @Prop([String, Number, Boolean])
  public initialValue!: string | number | boolean;

  @Prop(Boolean)
  public isRequired!: boolean;

  @Prop(Boolean)
  public showWarningIcon!: boolean;

  @Prop(Boolean)
  public isDisabled!: boolean;

  @Prop(Boolean)
  public mustCheck!: boolean;

  @Prop(String) public radioGroupErrorTitle!: string;

  @Prop(Number) public radioPadding!: number | null;

  public inputModel: string | number | boolean = '';
  public inputId: string | number | boolean = '';

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.inputModel = this.initialValue;
  }

  public onInput(): void {
    this.$emit('onInput', this.inputModel);
    this.$emit('input', this.inputModel);
  }

  public onClick(e): void {
    if (Utils.isIEorEDGE()) {
      if (('' + e.target.value === this.inputModel)) {
        this.inputModel = '';
        this.$emit('input', this.inputModel);
      } else {
        this.inputModel = e.target.value;
      }
    } else {
      if (('' + e.target.value === '' + this.inputModel) && !this.mustCheck) {
        this.inputModel = '';
        this.$emit('input', this.inputModel);
      } else {
        this.inputModel = e.target.value;
      }
    }
  }

  get disabledInitialValue(): string {
    const me = this;
    let str = '';
    this.radios.find(radio => {
      if (radio.value === me.initialValue || radio.value === +me.initialValue) {
        str = radio.label;
      }
    });
    return str;
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = this.isRequired;
    }
    return validator;
  }

}
